import React from "react";

const UnderlineLoader = () => {
  return (
    <div className="w-full h-0.5 overflow-hidden absolute bottom-0">
      <div className="w-3/2 h-1 bg-current opacity-40 absolute" />
      <div className="absolute bg-current h-1 animate-underlineLoaderIncrease" />
      <div className="absolute bg-current h-1 animate-underlineLoaderDecrease" />
    </div>
  );
};

export default UnderlineLoader;
